import { createMediator, type Mediator } from "@/shared/lib/componentHierarchy";
import {
  getHierarchyResourceSnapshot,
  useComponentNode,
  useHierarchyResource,
} from "@/shared/ui/component-hierarchy/hooks";
export function useErrorFallbackPresenter(): () => void {
  const mediator = useHierarchyResource<
    Mediator<boolean, { type: "app.reload" }, "reload">
  >((previous) =>
    createMediator<boolean, { type: "app.reload" }, "reload">(
      previous?.isDisposed
        ? (getHierarchyResourceSnapshot<boolean>(previous) ?? false)
        : false,
      (state) => ({
        status: "handled",
        state: true,
        effects: state ? [] : ["reload"],
      }),
      { runEffect: () => window.location.reload() },
    ),
  );
  const node = useComponentNode((event) => {
    if (event.type !== "app.reload") return "unhandled";
    mediator.dispatch({ type: "app.reload" });
    return "handled";
  });
  return (): void => {
    node.dispatch({ type: "app.reload" });
  };
}
